import { initializeApp } from 'firebase/app';
import { selectCurrentEnv } from './env/selectCurrentEnv';

const firebaseConfig = selectCurrentEnv();
const app = initializeApp(firebaseConfig);

export { app };
